 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"npm.decimal.js":"npm.decimal.js","npm.tesseract.js":"npm.tesseract.js"}[chunkId]||chunkId) + "." + "700e030b222cb8b08d4a" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-099e7735":1,"chunk-0ffe14ac":1,"chunk-1eb10a52":1,"chunk-3208e23e":1,"chunk-648f7cee":1,"chunk-3554a49f":1,"chunk-3d57855b":1,"chunk-67ff76d2":1,"chunk-71104bd0":1,"chunk-764485a9":1,"chunk-790b6d4f":1,"chunk-7c0a4e84":1,"chunk-7d10654d":1,"chunk-ca3fc870":1,"chunk-b047c76c":1,"chunk-f823dc38":1,"chunk-fd6e50d6":1,"chunk-1af63147":1,"chunk-140c104d":1,"chunk-199df1ba":1,"chunk-2582adee":1,"chunk-487455d2":1,"chunk-76ff826c":1,"chunk-598ee86e":1,"chunk-11dd7a7a":1,"chunk-61cc1c7c":1,"chunk-6765a470":1,"chunk-729bf466":1,"chunk-47fb3de3":1,"chunk-52b9d674":1,"chunk-61ca74a4":1,"chunk-6e537866":1,"chunk-4f02db66":1,"chunk-79c1ce61":1,"chunk-7be8d055":1,"chunk-b4122afe":1,"chunk-4ed91b46":1,"chunk-6372cd6c":1,"chunk-7f3b3778":1,"chunk-165c5ac8":1,"chunk-73642c38":1,"chunk-8d1df196":1,"chunk-340a4456":1,"chunk-50547729":1,"chunk-7916e1b7":1,"chunk-dd692362":1,"chunk-a30cdcf0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"npm.decimal.js":"npm.decimal.js","npm.tesseract.js":"npm.tesseract.js"}[chunkId]||chunkId) + "." + {"chunk-099e7735":"301cbe8e","chunk-0ffe14ac":"01242cca","chunk-1eb10a52":"717b8f6f","chunk-2d0a49bd":"31d6cfe0","chunk-3208e23e":"6af759f5","chunk-648f7cee":"30dcba3a","chunk-3554a49f":"1ddb7db7","chunk-3d57855b":"3aa011ca","chunk-67ff76d2":"a970f44c","chunk-71104bd0":"66a784c5","chunk-764485a9":"c7c55652","chunk-790b6d4f":"9a39e033","chunk-7c0a4e84":"a1fb8527","chunk-7d10654d":"b07a0873","chunk-ca3fc870":"da841871","chunk-b047c76c":"2c51eda3","chunk-f823dc38":"640867b6","chunk-fd6e50d6":"286d9c5b","chunk-1af63147":"d9e2807f","chunk-35ae5345":"31d6cfe0","chunk-140c104d":"7cef1747","chunk-199df1ba":"a6a13e3d","chunk-2582adee":"e0554cbb","chunk-487455d2":"544d356a","chunk-76ff826c":"6e308b7d","chunk-598ee86e":"8465021b","chunk-11dd7a7a":"8e05709f","chunk-61cc1c7c":"b267e627","chunk-6765a470":"bc8dace9","chunk-729bf466":"2a700775","chunk-47fb3de3":"1a3763da","chunk-52b9d674":"e153ee30","chunk-61ca74a4":"3a02846d","chunk-6e537866":"df737a3c","chunk-4f02db66":"31459250","chunk-79c1ce61":"ed978f70","chunk-7be8d055":"92c76769","chunk-b4122afe":"3ccaa42b","npm.decimal.js":"31d6cfe0","chunk-4ed91b46":"7ae3623b","chunk-6372cd6c":"6c2e3df4","chunk-7f3b3778":"e48e7c16","chunk-165c5ac8":"45bb7d60","chunk-73642c38":"7f905f9a","chunk-8d1df196":"7f085aff","chunk-340a4456":"a39da2b2","chunk-50547729":"895bf484","chunk-7916e1b7":"756fa774","chunk-dd692362":"d2021442","npm.tesseract.js":"31d6cfe0","chunk-a30cdcf0":"c94b4362"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm.core-js","npm.element-plus","npm.crypto-js","npm.axios","npm.babel","npm.vue","npm.ctrl","npm.intlify","npm.floating-ui","npm.vueuse","npm.popperjs","npm.async-validator","npm.js-md5","npm.lodash","npm.pinia","npm.vue-i18n","npm.vue-router","vendors~app"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
